(ns ui.view.entry-criteria.model
  "Model-level constants for the stage entry-criteria modal: ident generation,
   per-scope ident derivation, and our own rf-state tree for association
   edits made inside the modal (the base entity-creator state tree handles
   field edits per scope, but doesn't model person-associations — so we keep
   association-edits in a separate state tree keyed by the modal's root ident).

   Each opening of the criteria modal owns a root `:ident` (auto-generated by
   `add-ident` if not provided). Per-scope creator-state instances live under
   that root via `scope-ident`, so multiple concurrent criteria modals keep
   cleanly partitioned state.")

(def root ::state)
(def root-path [root])

(defn i-root
  [ident]
  {:pre [(vector? ident)]}
  (into root-path ident))

(def associations-edits-key :associations-edits)
(def associations-edits-path [associations-edits-key])
(defn associations-edits-full-path
  [ident]
  (into (i-root ident) associations-edits-path))

(def nested-association-creator-key :nested-association-creator)

(defn add-ident
  "Ensures `:ident` is present in `props`. Generates a fresh keyword-vector
   ident if missing, like `frontend.view.entity-creator.view/add-ident`."
  [{:keys [ident] :as props}]
  (let [ident (or ident
                  (-> "entry-criteria-"
                      gensym
                      str
                      keyword
                      vector))]
    (assoc props :ident ident)))

(defn scope-ident
  "Returns the per-scope ident for one of `:opportunity` / `:target` /
   `:target-profile` — each scope's creator-state lives under
   `[ident :nested scope]` so the root ident's three sub-trees stay
   cleanly partitioned."
  [{:keys [ident]} scope]
  (into ident [:nested scope]))

(defn resolve-nested-association-creator-ident
  "Ident for the nested entity-creator (e.g. person creator) opened from an
   association multi-select's `:create!`."
  [{:keys [ident]} association-key]
  (into ident [nested-association-creator-key association-key]))

;; Subscriptions
(def root-state ::root-state)
(def state ::state-instance)
(def associations-edits ::associations-edits)
(def association-edits ::association-edits)

;; Events
(def set-association ::set-association)
(def clear-state ::clear-state)
